import { createFileRoute } from '@tanstack/react-router';

import { ForgotPasswordPage } from '#modules/user/features/auth/pages/ForgotPassword';

export const Route = createFileRoute('/{-$locale}/_layout/forgot-password')({
  component: ForgotPasswordPage,
  ssr: false,
});
